import { getNextEventInstance } from '../utils/util_date_checker';

import { apiWrapper } from './helpers';
import { cloneDeep } from 'lodash';

// region Get Activity List
export function getActivityList(currentPage = 1, pageSize = 10, keyword = '', citySlug = 'denver', stateShortName = 'CO') {
    return new Promise((resolve, reject) => {
        apiWrapper(
            `/vendor/v1/events/activity?keyword=${keyword.toLowerCase()}&page=${currentPage}&per_page=${pageSize}&city=${citySlug}&state=${stateShortName}`,
            'GET',
            'GET ACTIVITY LIST'
        )
            .then((response) => {
                // Sort calendar
                const eventArr = response.data
                    .filter((eventItem) => eventItem.events?.length > 0)
                    .map((eventItem) => {
                        let upcomingEvent = eventItem.events[0],
                            nextEventData = getNextEventInstance(upcomingEvent),
                            tempObj = Object.assign(cloneDeep(eventItem), {
                                address: upcomingEvent.address,
                                timeObj: nextEventData,
                                latitude: upcomingEvent['latitude'],
                                longtitude: upcomingEvent['longtitude']
                            });

                        return(tempObj);
                    })
                    .filter((eventItem) => !!eventItem.timeObj);

                eventArr.sort((a, b) => a.timeObj.startTime - b.timeObj.startTime);

                // Remove duplicated events
                const tempArr = eventArr.filter((thing, index, self) => index === self.findIndex((t) => (
                    (t.address === thing.address) && (t.name === thing.name)
                )));

                // Return new data
                resolve(Object.assign({}, response, { data: tempArr }));
            })
            .catch((errorText) => reject(errorText));
    });
}
// endregion
